import React from 'react';
import { Form, Radio, Alert, Divider } from 'antd';
import EmployeeSelect from '../common/EmployeeSelect';
import GroupSelect from '../common/GroupSelect';
import TagSelect from '../common/TagSelect';

const TargetSelector = ({ 
  isScheduled = false,
  tags = [],
  groups = [],
  form
}) => {
  if (!isScheduled) {
    return null;
  }

  return (
    <div style={{ marginTop: '16px', marginBottom: '16px' }}>
      <Divider orientation="left">选择人群</Divider>

      {/* 步骤目标类型选择 */}
      <Form.Item
        name="stepTargetType"
        label="目标类型"
        initialValue="TAG"
        rules={[{ required: true, message: '请选择目标类型' }]}
      >
        <Radio.Group
          onChange={(e) => {
            console.log("目标类型变更为:", e.target.value);
            // 如果选择ALL，则清空已选标签
            if (e.target.value === 'ALL') {
              form.setFieldsValue({ stepTargetIds: [] });
            }

            // 如果修改为GROUP，清空已选企业微信成员
            if (e.target.value === 'GROUP') {
              form.setFieldsValue({ stepEmployeeIds: [] });
            }
          }}
        >
          <Radio value="TAG">按标签</Radio>
          <Radio value="GROUP">按客户群</Radio>
          <Radio value="ALL">全部客户</Radio>
        </Radio.Group>
      </Form.Item>

      {/* 根据目标类型显示不同的选择器 */}
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.stepTargetType !== currentValues.stepTargetType
        }
      >
        {({ getFieldValue }) => {
          const targetType = getFieldValue('stepTargetType');
          console.log("目标类型表单值:", targetType);

          if (targetType === 'TAG') {
            return (
              <Form.Item
                name="stepTargetIds"
                label="选择标签"
                rules={[{
                  required: true,
                  message: '请至少选择一个标签'
                }]}
              >
                <TagSelect
                  mode="multiple"
                  placeholder="请选择标签（可多选）"
                  width={'100%'}
                />
              </Form.Item>
            );
          } else if (targetType === 'GROUP') {
            return (
              <Form.Item
                name="stepTargetIds"
                label="选择客户群"
                rules={[{
                  required: true,
                  message: '请至少选择一个客户群'
                }]}
              >
                <GroupSelect
                  groups={groups}
                  mode="multiple"
                  placeholder="请选择客户群（可多选）"
                  style={{ width: '100%' }}
                  valueKey="id"
                  labelKey="name"
                  valueType="string"
                  showOwner={false}
                />
              </Form.Item>
            );
          } else if (targetType === 'ALL') {
            return (
              <Alert
                message="将向所有客户发送此步骤内容"
                type="warning"
                showIcon
                style={{ marginBottom: '12px', padding: '10px 24px', border: 'none'  }}
              />
            );
          }

          return null;
        }}
      </Form.Item>

      {/* 只在目标类型不是GROUP时显示执行人设置 */}
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.stepTargetType !== currentValues.stepTargetType
        }
      >
        {({ getFieldValue }) => {
          const targetType = getFieldValue('stepTargetType');
          console.log("目标类型表单值(执行人部分):", targetType);

          if (targetType !== 'GROUP') {
            return (
              <>
                <Divider orientation="left">选择执行人</Divider>

                <Form.Item
                  name="stepEmployeeIds"
                  label="指定企业微信成员"
                  rules={[{ required: true, message: '请至少选择一个企业微信成员' }]}
                >
                  <EmployeeSelect
                    multiple
                    placeholder="请选择或搜索执行此步骤的企业微信成员（可多选）"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </>
            );
          }

          return null;
        }}
      </Form.Item>
    </div>
  );
};

export default TargetSelector; 